import { useTheme } from '@classify/react-core-components/styles';
function useColorByStatus(status) {
  const {
    palette
  } = useTheme();
  const colorMap = {
    notStarted: ["not started", "pending", "canceled", "late canceled", "not-followed"],
    success: ["passed", "ready for review", "completed"],
    fail: ["failed", "marked student as absent", "critically-late"],
    awaiting: ["awaiting review", "on-track-in-advance"],
    retry: ["retry", "late", "on-track-slightly-late"],
    inProgress: ["in progress", "in-advance", "followed"]
  };
  let colorToReturn = "notStarted";
  Object.entries(colorMap).forEach(t0 => {
    const [color, statusesMap] = t0;
    if (statusesMap.includes(status)) {
      colorToReturn = color;
    }
  });
  return palette.status[colorToReturn];
}
export default useColorByStatus;